<template>
  <div>
    <TableWrapper
      :loading="loading"
      :errorMsg="errorMsg"
      :refetch="fetchWebHooks"
      :isEmpty="isEmpty"
      :emptyTitle="emptyTitle"
    >
      <div class="w-100 py-3" slot="content">
        <v-server-table
          class="v-table row-pointer"
          :data="customers"
          :columns="columns"
          :options="options"
          @loaded="onLoaded"
        >
          <template slot="discountType">
            Secret Key
          </template>
          <template slot="testWebhook">
            ****
          </template>
        </v-server-table>
      </div>
    </TableWrapper>
  </div>
</template>

<script>
import { componentData } from "../../../../../../public/assets/mixins/componentData";
import TableWrapper from "../../../../../components/utils/TableWrapper/TableWrapper.vue";

const plansHeadings = {
  discountType: "Key Type",
  testWebhook: "Key",
  testWebehook: " ",
};

export default {
  name: "WebHooks",
  mixins: [componentData],
  data() {
    return {
      singleInviteObj: null,
      showSingleInviteModal: false,
      emptyTitle: "No WebHook Found",
      showInviteModal: false,
      loading: false,
      errorMsg: "",
      customers: [],
      ...this.tableOptions(plansHeadings, 25),
    };
  },
  components: {
    TableWrapper,
  },
  methods: {
    async fetchWebHooks() {
      this.options.requestFunction = async (data) => {
        const params = { ...data, ...this.filters, reference: this.clientid };
        const response = await this.$store.dispatch(
          "customer/getSettingsInfo",
          {
            params,
          }
        );

        const newData = [response.data.apiAndWebhooks.data];
        return { count: 1, total: 1, data: newData };
      };
    },
  },

  props: ["clientid"],
  created() {
    this.fetchWebHooks();
  },
  mounted() {
    this.columns = Object.keys(plansHeadings).map((keyVal) => keyVal);
  },
};
</script>
